export const ARTICLE_PUBLISH = "publishArticle";
export const ARTICLE_DELETE = "deleteArticle";
export const ARTICLE_EDIT = "editArticle";
export const ARTICLE_EDIT_ADD_TAG = "addTagToArticle";
export const ARTICLE_EDIT_REMOVE_TAG = "removeTagFromArticle";
export const ARTICLE_RESET_STATE = "resetArticleState";
export const CHECK_AUTH = "checkAuth";
export const COMMENT_CREATE = "createComment";
export const COMMENT_DESTROY = "destroyComment";
export const FAVORITE_ADD = "addFavorite";
export const FAVORITE_REMOVE = "removeFavorite";
export const FETCH_ARTICLE = "fetchArticle";
export const FETCH_ARTICLES = "fetchArticles";
export const FETCH_COMMENTS = "fetchComments";
export const FETCH_PROFILE = "fetchProfile";
export const FETCH_PROFILE_FOLLOW = "fetchProfileFollow";
export const FETCH_PROFILE_UNFOLLOW = "fetchProfileUnfollow";
export const FETCH_TAGS = "fetchTags";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const UPDATE_ADMIN_LOGGED_STATUS = "adminLoggedIn";
export const FETCH_DECORATION_TEMPLATE = "fetchDecorationTemplate";
export const FETCH_DECORATION_PRICES = "fetchDecorationPrices";
export const FETCH_ADMIN_OPTIONS = "fetchAdminOptions";
export const FETCH_ALL_DECORATION_TEMPLATES = "fetchAllDecorationTemplates";
export const FETCH_DECORATION_METHODS = "decorationMethods";
export const SET_DECORATION_METHOD_NAME = "decorationMethodName";
export const FETCH_ROLLUP_FEES = "fetchRollupFees";
export const FETCH_ECOMM_DISPLAY_NAMES = "fetchEcommDisplayNames";
export const FETCH_INDUSTRY_MATCHED_USER = "fetchIndustryMatchedUser";